export var validateEmail = function (email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
};
export var devPlanTrialRemainsData = function (currentTrialPeriod, consumedTrialPeriod, selectedTrialPeriod) {
    var currentRemainingTrial = currentTrialPeriod - consumedTrialPeriod;
    var additionalDaysWhenSelectNewTrial = selectedTrialPeriod - currentTrialPeriod;
    var remainingDaysWhenSelectNewTrial = selectedTrialPeriod - consumedTrialPeriod;
    return {
        isVisible: currentTrialPeriod > 0 &&
            selectedTrialPeriod > 0 &&
            additionalDaysWhenSelectNewTrial > 0,
        remainingForCurrent: currentRemainingTrial,
        remainingForSelected: remainingDaysWhenSelectNewTrial,
        additionalForSelected: additionalDaysWhenSelectNewTrial,
    };
};
